/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargo_Create_DescriptionInputs */

const en_cargo_create_description = /** @type {(inputs: Cargo_Create_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a new cargo lot to inventory.`)
};

const es_cargo_create_description = /** @type {(inputs: Cargo_Create_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agrega un nuevo lote de carga al inventario.`)
};

/**
* | output |
* | --- |
* | "Add a new cargo lot to inventory." |
*
* @param {Cargo_Create_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargo_create_description = /** @type {((inputs?: Cargo_Create_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargo_Create_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargo_create_description(inputs)
	return es_cargo_create_description(inputs)
});